/**
 * Voci della barra di navigazione flottante.
 * `adminOnly` limita la voce agli amministratori (livello 0 e 1).
 */
export const navigationLinks = [
    {
        label: 'Calendario',
        path: '/prenota',
        icon: 'calendar-days'
    },
    {
        label: 'Prenotazioni',
        path: '/prenotazioni',
        icon: 'list-check'
    },
    {
        label: 'Admin',
        path: '/admin',
        icon: 'users-gear',
        adminOnly: true
    },
    {
        /* In fondo perche' e' l'unica voce che non riguarda le prenotazioni.
           Ci si arriva anche dal nome in testata, ma li' e' un bersaglio
           piccolo e su telefono la testata scorre via col contenuto. */
        label: 'Profilo',
        path: '/profile',
        icon: 'circle-user'
    }
];
